import { render } from "./ConsultationAdditionalInformationTab.vue?vue&type=template&id=71ec5264&scoped=true"
import script from "./ConsultationAdditionalInformationTab.vue?vue&type=script&lang=js"
export * from "./ConsultationAdditionalInformationTab.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./ConsultationAdditionalInformationTab.vue?vue&type=style&index=1&id=71ec5264&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ec5264"]])

export default __exports__